export const MAX_FILE_SIZE_BYTES = 30 * 1024 * 1024;
export const MAX_FILE_SIZE_LABEL = '30 MB';

export type FileValidationCode =
  'ok' | 'empty' | 'legacy-xls' | 'extension' | 'too-large' | 'signature';

export interface FileValidationResult {
  readonly valid: boolean;
  readonly code: FileValidationCode;
  readonly message: string;
}

const VALID_XLSX_SIGNATURES: readonly (readonly number[])[] = [
  [0x50, 0x4b, 0x03, 0x04],
  [0x50, 0x4b, 0x05, 0x06],
  [0x50, 0x4b, 0x07, 0x08],
];

export async function validateSelectedFile(file: File): Promise<FileValidationResult> {
  const normalizedName = file.name.trim().toLocaleLowerCase('zh-CN');
  if (file.size === 0) {
    return result(false, 'empty', '文件为空，请重新导出有效的 .xlsx 文件。');
  }
  if (normalizedName.endsWith('.xls')) {
    return result(false, 'legacy-xls', '暂不支持 .xls，请先在 Excel 或计价软件中另存为 .xlsx。');
  }
  if (!normalizedName.endsWith('.xlsx')) {
    return result(false, 'extension', '仅支持 .xlsx 文件，请检查文件扩展名。');
  }
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return result(false, 'too-large', `文件超过 ${MAX_FILE_SIZE_LABEL} 限制，请拆分后再检查。`);
  }

  const signature = new Uint8Array(await file.slice(0, 4).arrayBuffer());
  if (!VALID_XLSX_SIGNATURES.some((candidate) => matchesSignature(signature, candidate))) {
    return result(
      false,
      'signature',
      '文件内容不是有效的 .xlsx 压缩包，可能已损坏或扩展名不正确。',
    );
  }
  return result(true, 'ok', '文件校验通过。');
}

function matchesSignature(actual: Uint8Array, expected: readonly number[]): boolean {
  return expected.every((byte, index) => actual[index] === byte);
}

function result(valid: boolean, code: FileValidationCode, message: string): FileValidationResult {
  return { valid, code, message };
}
